import { render, staticRenderFns } from "./DelShipment.vue?vue&type=template&id=8a69c85a"
import script from "./DelShipment.vue?vue&type=script&lang=js"
export * from "./DelShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports